import React from "react";
import "../newleaderboard.css";
import sapphireRank from "../assets/sapphireRank.svg";
import azureRank from "../assets/azureRank.svg";
import crystalRank from "../assets/crystalRank.svg";
import eclipseRank from "../assets/eclipseRank.svg";
import rightArrow from "../assets/rightArrow.svg";
import { NavLink, useLocation } from "react-router-dom";

const RankView = () => {
  const location = useLocation();

  const { rank } = location.state || 0;

  const ranks = [
    {
      image: sapphireRank,
      title: "Sapphire Spark",
      desc: `
       <div class="d-flex align-items-center flex-column gap-4">
          <span class="new-rank-desc">Everyone starts here</span>
          <span class="new-rank-desc">
            Begin your journey by completing the first task.
          </span>
        </div>
      `,
    },
      
    {
      image: azureRank,
      title: "Azure Crest",
      desc: `
       <div class="d-flex align-items-start flex-column gap-4">
          <span class="new-rank-desc">Unlock this badge to qualify for the raffle draw</span>
          <div class="d-flex align-items-start flex-column gap-2">
          <span class="new-rank-desc">
            🏆 100 random winners receive $5 each
          </span>
          <span class="new-rank-desc">
            🎯 Weekly Badge
          </span> 
          <span class="new-rank-desc">
            📅 Active until every Monday 2:00 PM UTC
          </span>
        </div>
      `,
    },
    {
      image: crystalRank,
      title: "Crystal Crown",
      desc: `
       <div class="d-flex align-items-start flex-column gap-4">
          <span class="new-rank-desc">Unlock this badge to enter the premium raffle</span>
          <div class="d-flex align-items-start flex-column gap-2">
          <span class="new-rank-desc">
            🏆 50 random winners receive $10 each
          </span>
          <span class="new-rank-desc">
            🎯 Weekly Badge
          </span> 
          <span class="new-rank-desc">
            📅 Active until every Monday 2:00 PM UTC
          </span>
        </div>
      `,
    },
    {
      image: eclipseRank,
      title: "Eclipse Core",
      desc: `
       <div class="d-flex align-items-start flex-column gap-4">
          <span class="new-rank-desc">Reach the top tier and instantly secure rewards</span>
          <div class="d-flex align-items-start flex-column gap-2">
          <span class="new-rank-desc">
            💰 Guaranteed $200 reward
          </span>
          <span class="new-rank-desc">
            🎯 No raffle. Earn it through effort
          </span> 
          <span class="new-rank-desc">
            📅 Active until every Monday 2:00 PM UTC
          </span>
        </div>
      `,
    },
  ];

  return (
    <div className="container-fluid leaderboard-wrapper d-flex align-items-end px-0 position-relative">
      <NavLink
        to={"/leaderboard/progress"}
        className="rank-back-button rank-back-button-position d-flex justify-content-center align-items-center mx-4 my-3"
      >
        <img
          src={rightArrow}
          style={{ transform: "rotate(180deg)" }}
          width={15}
          height={15}
          alt=""
        />
      </NavLink>
      <div className="new-rank-wrapper d-flex flex-column gap-5 justify-content-center align-items-center position-relative">
        <img src={ranks[rank].image} alt="" className="new-rank-badge" />
        <h6 className="mb-0 new-rank-title">{ranks[rank].title}</h6>
        <div dangerouslySetInnerHTML={{__html: ranks[rank].desc}}></div>
      </div>
    </div>
  );
};

export default RankView;
